import { useTranslation } from "react-i18next";
import LegalPage, { type LegalSection } from "@/components/public/LegalPage";
import { SUBPROCESSORS } from "@/lib/subprocessors";

const SECTIONS: LegalSection[] = [
  { id: "intro" },
  { id: "subprocessors" },
  { id: "transfers" },
  { id: "security" },
  { id: "dpa" },
];

function SubprocessorTable() {
  const { t } = useTranslation();
  return (
    <div className="overflow-x-auto rounded-lg border border-border">
      <table className="w-full text-sm">
        <thead className="bg-secondary/40 text-left text-xs uppercase tracking-wider text-muted-foreground">
          <tr>
            <th className="px-3 py-2">{t("legal.trust.tableHeaders.name")}</th>
            <th className="px-3 py-2">{t("legal.trust.tableHeaders.country")}</th>
            <th className="px-3 py-2">{t("legal.trust.tableHeaders.purpose")}</th>
            <th className="px-3 py-2">{t("legal.trust.tableHeaders.data")}</th>
            <th className="px-3 py-2">{t("legal.trust.tableHeaders.basis")}</th>
            <th className="px-3 py-2">{t("legal.trust.tableHeaders.dpa")}</th>
          </tr>
        </thead>
        <tbody>
          {SUBPROCESSORS.map((sp) => (
            <tr key={sp.name} className="border-t border-border align-top">
              <td className="px-3 py-2 font-medium text-foreground">{sp.name}</td>
              <td className="px-3 py-2 text-muted-foreground">{sp.country}</td>
              <td className="px-3 py-2 text-muted-foreground">{sp.purpose}</td>
              <td className="px-3 py-2 text-muted-foreground">{sp.data}</td>
              <td className="px-3 py-2 text-muted-foreground">{sp.basis}</td>
              <td className="px-3 py-2">
                {sp.dpa === "—" ? (
                  <span className="text-muted-foreground">—</span>
                ) : (
                  <a href={sp.dpa} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    DPA
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const SECTIONS_WITH_TABLE: LegalSection[] = SECTIONS.map((section) =>
  section.id === "subprocessors" ? { ...section, children: <SubprocessorTable /> } : section,
);

export default function Trust() {
  return (
    <LegalPage
      namespace="legal.trust"
      sections={SECTIONS_WITH_TABLE}
      lastUpdated="2026-05-13"
      contactEmail="dpo@delapresse.fr"
    />
  );
}
